import { z } from 'zod'

export const PortfolioStatusSchema = z.enum([
  'Total Portfolio',
  'Open - Good Standing',
  'Settled - Check on the Way',
  'Settled - Reductions',
  'Unknown',
  'Pending Replacement',
  'Settled - Unpaid',
  'Settled - Partially Paid',
])

export type PortfolioStatus = z.infer<typeof PortfolioStatusSchema>
